var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-2"},[_c('div',[_vm._v("Response")]),_vm._l((_vm.submissions),function(item,index){return _c('div',{key:index,staticClass:"p-2 border border-secondary-20 rounded-md"},[_vm._v("\n    "+_vm._s(item[0])+": "),_c('b',[_vm._v(_vm._s(item[1])+"/"+_vm._s(_vm.highValue))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }